import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { Element } from '../../../../common/html/element'
import { changeDataInCell } from '../store/slice'
import { putUpdateAlertCompany } from '../store/thunk'

export const CustomTdAlertDetail = ({ val, rowId }) => {
  const dispatch = useDispatch()
  const [searchId] = useSearchParams()
  const id = searchId.get('id')

  const handleChange = () => {
    dispatch(
      putUpdateAlertCompany({
        portfolioIds: [id],
        organizationIds: [rowId],
        alertStatusId: !val,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(
          changeDataInCell({ rowId, colId: 'alertStatusId', value: !val }),
        )
      })
      .catch(() => {})
  }

  return (
    <Element
      elementName="p"
      style={{
        color: val ? '#3DA967' : '#9C9C9C',
      }}
      onClick={handleChange}
      className="cursorPointer"
    >
      {val ? (
        <Translate value="library.main.ON_ALERT" />
      ) : (
        <Translate value="library.main.OFF_ALERT" />
      )}
    </Element>
  )
}
